module.exports = __webpack_public_path__ + "static/media/400413_02.d253aac8.png";